<template>
  <div class="colorfulLife">
    <h3>缤纷生活</h3>
    <!-- <el-card class="box-card" :body-style="{ padding: '0px' }">
      <table>
        <tr>
          <td>
            <img
              :src="require('../assets/colorlife/icon_holiday_care.png')"
              alt
              style="width:120px;height:110px;margin-top: 35px;margin-bottom: 35px;margin-left:76px;margin-right: 36px;"
            />
          </td>
          <td style="text-align: left;">
            <p
              style="font-size:1.125rem;line-height: 1.75rem;font-weight:600;color:#1A1A1A;margin-bottom: 15px;"
            >
              假期关怀
            </p>
            <p style="font-size:.875rem;line-height: 1.375rem;font-weight:400;color:#777777">
                          公司为员工提供多种全薪假期，包括法定节假日、女生节假期（3.8）、亲子假（6.1）、春节探亲假、带薪事假、产检假、产假、哺乳假、
                          <br />陪产假、计划生育假、丧假及路程假等。
                          <br />员工通过试用期考察，转为正式员工后可享受年假待遇，除了法定年休假外，按照司龄还可享有奖励司龄年休假。
                      </p>
          </td>
        </tr>
      </table>
    </el-card> -->

    <div class="actives">
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in actives"
          :key="index"
          :span="6"
          style="margin-top: 30px;"
        >
          <el-card class="active">
            <div>
              <img
                :src="item.icon"
                alt
                style="width: 120px; height: 110px; margin-top: 40px;margin-bottom: 15px;"
              />
              <span
                style="font-size:1.125rem;line-height: 1.75rem;color:#1A1A1A;font-weight: 600;text-align: center;display: block;margin-bottom: 15px;"
                >{{ item.title }}</span
              >
              <!-- <div v-html="item.desc" style="font-size:14px;line-height: 1.375rem;color: #777777;"></div> -->
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped>
.colorfulLife {
  position: relative;
  display: inline-block;
  flex-flow: column;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
}
h3 {
  padding-top: 50px;
  padding-bottom: 50px;
  color: #1a1a1a;
  font-size: 24px;
  line-height: 36px;
}

.el-card {
  border-radius: 10px;
}

.box-card {
  width: 60%;
  max-width: 1200px;
  min-width: 1200px;
}
.actives {
  width: 60%;
  max-width: 1200px;
  min-width: 1200px;
  margin-bottom: 30px;
  display: inline-block;
}
.active {
  height: 262px;
  background-color: #fff;
}
</style>
<script>
export default {
  data() {
    return {
      msg: "缤纷生活",
      banners: [{ url: require("../assets/welfare/header.png") }],
      actives: [
        {
          icon: require("../assets/colorlife/icon_holiday_care.png"),
          title: "假期关怀",
          desc:
            ""
        },
        {
          icon: require("../assets/colorlife/icon_01.png"),
          title: "开工红包",
          desc:
            "在春节假期后复工的第一天，<br/>公司给员工派发“开工红包”，<br/>祝福员工在新年伊始就得到佳绩，<br/>开工大吉。"
        },
        {
          icon: require("../assets/colorlife/icon_02.png"),
          title: "节庆活动",
          desc: "举办多样化节日庆祝活动，<br/>与员工一起欢度佳节。"
        },
        {
          icon: require("../assets/colorlife/icon_03.png"),
          title: "月度团建",
          desc:
            "公司为每一位员工提供了<br/>月度部门活动经费，<br/>更好地促进同事之间的沟通和交流。"
        },
        {
          icon: require("../assets/colorlife/icon_04.png"),
          title: "月度下午茶",
          desc:
            "公司每月为员工提供下午茶福利，<br/>工作之余放松心情，<br/>享受闲适时光。"
        },
        // {
        //     icon: require('../assets/colorlife/icon_05.png'),
        //     title: '年度旅游',
        //     desc: '公司每年组织一次出游活动，<br/>鼓励员工轻松出发、<br/>玩得尽兴。',
        // },
        // {
        //     icon: require('../assets/colorlife/icon_06.png'),
        //     title: '年会',
        //     desc: '公司每年举办一场“家庭盛宴”，<br/>吃喝玩乐，心跳抽奖，<br/>士气激昂，展望未来。',
        // },
        {
          icon: require("../assets/colorlife/icon_07.png"),
          title: "企业滴滴",
          desc:
            "为解决员工的加班出行问题，<br/>公司引进企业滴滴的便捷服务，<br/>让员工用心上班、平安到家。"
        },
        {
          icon: require("../assets/colorlife/icon_08.png"),
          title: "暖心慰问",
          desc:
            "生日礼金、结婚贺礼、<br/>生育礼金、 住院及工伤慰问、<br/>丧事帛金等。"
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ColorfulLife.vue